import { createStore, applyMiddleware } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

import reducers from "../Reducers";
import { composeWithDevTools } from "redux-devtools-extension";

const logger = (store) => {
  return (next) => {
    return (action) => {
      const result = next(action);
      // console.log(store);
      // console.log(action);
      return result;
    };
  };
};

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(logger)));
export default store;
